import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.mitteilungs-vorlage-empfaenger-rollen-entfernen';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationMitteilungsVorlageEmpfaengerRollenEntfernenEffects {

    MitteilungsVorlageEmpfaengerRollenEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_MITTEILUNGS_VORLAGE_EMPFAENGER_ROLLEN_ENTFERNEN),
        mergeMap((x: ac.PostMitteilungsVorlageEmpfaengerRollenEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postMitteilungsVorlageEmpfaengerRollenEntfernen(x.mitteilungsVorlageRolleMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostMitteilungsVorlageEmpfaengerRollenEntfernenErfolgreichAction(result, x.mitteilungsVorlageRolleMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostMitteilungsVorlageEmpfaengerRollenEntfernenFehlerAction(error, x.mitteilungsVorlageRolleMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungsVorlageCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungsVorlageCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungsVorlageCommandService);
        }
        return this.service;
    }
}
